import { atom } from 'jotai'
import { atomFamily } from 'jotai/utils'

export interface NewsDraft {
  body: string
  externalUrl?: string
  image?: File
  imageAction?: 'keep' | 'remove'
  originalVersion?: number
  blocked?: boolean
}

const draftKeys = new Set<string>()
const draftFamily = atomFamily((_key: string) => atom<NewsDraft | undefined>(undefined))

export const newsDraftKey = (uid: string, kind: 'new-post' | 'edit-post' | 'new-comment' | 'edit-comment', id = '') => `${uid}:${kind}:${id}`

export const newsDraftAtom = (key: string) => {
  draftKeys.add(key)
  return draftFamily(key)
}

export const clearNewsDraftsAtom = atom(null, (_get, set, uid: string) => {
  for (const key of [...draftKeys]) {
    if (!key.startsWith(`${uid}:`)) continue
    set(draftFamily(key), undefined)
    draftFamily.remove(key)
    draftKeys.delete(key)
  }
})
